import { computed, observable } from 'mobx';
import { useRef } from 'react';
import { noop } from '@src/utils/common-util';
import copy from '@src/components/copy';
import { aLink } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import Toast from '@src/components/toast';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const navListLocales = pageLocalesData.topBar.navList;
const lang = getLanguageByPath();
class TopMenuStore {
  @observable isOpenCompetition = false; // 是否展示赛事

  @computed
  get navList() {
    return [
      { type: '首页', id: 1, url: '', name: navListLocales[0].name },
      { type: '限时活动', id: 2, url: '', isHot: true, name: navListLocales[1].name },
      { type: '创作招募', id: 99, url: `https://mechabreak.seasungames.com/creator_program/m/${lang}/`, name: navListLocales[2].name },
      { type: '版本亮点', id: 3, url: '', name: navListLocales[3].name },
      {
        type: '地图',
        id: 4,
        url: '',
        name: navListLocales[4].name
      },
      {
        type: '空投',
        id: 5,
        url: '',
        name: navListLocales[5].name
      },
      {
        type: '飞行踏板',
        id: 6,
        url: '',
        name: navListLocales[6].name
      },
      {
        type: '敌对目标',
        id: 7,
        url: '',
        name: navListLocales[7].name
      },
      {
        type: '新闻资讯',
        id: 100,
        url: '',
        name: navListLocales[8].name
      }
    ].filter(item => {
      if (this.isOpenCompetition === false) {
        // 如果 `isOpenCompetition` 为 false, 隐藏 "官方赛事"
        if (item.id === 2) {
          return false;
        }
        // 如果 `id` 大于 2 且小于 99, 对 `id` 减 1
        if (item.id > 2 && item.id < 99) {
          item.id -= 1;
        }
      }
      return true; // 其他情况，保留项
    });
  }

  @observable currentIndex = 0;

  @observable clickChangeSwiper = noop;

  @observable onLoginBtn = noop;
  //
  @observable isPause = true; // 是否暂停播放
  // 打开菜单
  @observable menuState = false;

  @observable newsUrl; //新闻资讯

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  clickMenu = (id, url, index) => {
    if (id === 100) {
      aLink(this.newsUrl);
      return;
    }
    if (id === 99 && url) {
      aLink(url);
      return;
    }
    this.currentIndex = index;
    this.clickChangeSwiper(id);
    this.onchangeMenu(false);
  };

  onchangeMenu = menuState => {
    this.menuState = menuState;
  };

  @autobind
  async onExitBtnClick() {
    try {
      await this.exitRequest.run();
      window.location.reload();
    } catch (e) {
      Toast.info(e.message);
    }
  }

  loginClick = () => {
    this.onLoginBtn();
  };

  onShare(method) {
    console.log(method);
    switch (method.action) {
      case 'link':
        aLink(method.link);
        break;
      case 'copy-link':
        copy(method.link);
        break;
      default:
        break;
    }
  }

  use() {
    this.menuRef = useRef(null);
  }
}
export default TopMenuStore;
